module.exports = __webpack_public_path__ + "static/media/fa-solid-900.79b9a4aa.woff";